import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import SwipeableViews from 'react-swipeable-views'

import buildAssetUrl from '../utils/buildAssetUrl'

import { MediaContainer, SliderControls } from '../components'

const styles = {
  containerStyle: {
    marginTop: 30,
    border: '1px solid #d6d8db'
  }
}

class SlidingMedias extends Component {
  state = {
    activeIndex: 0
  }

  handleChangeIndex = activeIndex => this.setState({ activeIndex })

  render() {
    const {
      medias,
      classes: { containerStyle }
    } = this.props
    const { activeIndex } = this.state

    return (
      <div className={`${containerStyle} sliding-medias-container`}>
        <SwipeableViews
          index={activeIndex}
          onChangeIndex={this.handleChangeIndex}
          style={{
            width: '100%',
            height: '100%',
            flexShrink: 0,
            overflow: 'hidden'
          }}
          slideStyle={{
            overflow: 'hidden'
          }}
        >
          {medias.map((medium, index) => {
            const { asset, localizedAsset, description } = medium

            const { type, url } = localizedAsset
              ? buildAssetUrl(localizedAsset)
              : buildAssetUrl(asset)

            const image = type === 'image' ? url : null
            const video = type === 'video' ? url : null

            return (
              <MediaContainer
                key={index}
                image={image}
                video={video}
                // markers={markers}
                caption={description}
                alt={description}
              />
            )
          })}
        </SwipeableViews>

        {medias.length > 1 && (
          <SliderControls
            activeIndex={activeIndex}
            mediaAmount={medias.length}
            onChangeIndex={this.handleChangeIndex}
          />
        )}
      </div>
    )
  }
}

SlidingMedias.propTypes = {
  medias: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(SlidingMedias)



// WEBPACK FOOTER //
// ./src/components/SlidingMedias.js